import Vue from 'vue';
import store from './store';
import '@mdi/font/css/materialdesignicons.css';
// import VueI18n from 'vue-i18n'
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
// import i18n from "./plugins/i18n";
import Chart from 'chart.js'
import VueParticles from 'vue-particles'
import Toast from "vue-toastification";
//import VueMarkdown from "vue-markdown";
import "vue-toastification/dist/index.css";
import 'intl-tel-input/build/css/intlTelInput.css';

// import "./tw.css";

//global methods
import g from './global/globalMethods'
//helpers
import {messageHelper} from './store/helper'


// Vue.use(VueHtml2pdf)
Vue.use(VueParticles)
Vue.use(Toast, {
  transition: "Vue-Toastification__fade",
  maxToasts: 20,
  newestOnTop: true
});
//Vue.use(VueMarkdown);

Vue.config.productionTip = false;

Vue.prototype.$mainColor = '#185ba6';
Vue.prototype.g = g;
Vue.prototype.$messageHelper = messageHelper
new Vue({
  vuetify,
  router,
  store,
  // i18n,
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  render: (h) => h(App),
}).$mount('#app');
